// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export interface ControlHint {
	key: string;
	hint: string;
}

@customElement('control-hints')
export class ControlHints extends LitElement {
	@property({ type: Array })
	hints: ControlHint[] = [];

	static override styles = css`\
:host {
	position: fixed;
	bottom: 2em;
	right: 4em;
	display: flex;
	gap: 24px;
	font-size: 12px;
	color: #888;
	font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
}

.control-hint {
	display: flex;
	align-items: center;
	gap: 8px;
}

.control-key {
	background: rgba(255, 255, 255, 0.1);
	border: 1px solid rgba(255, 255, 255, 0.2);
	border-radius: 4px;
	padding: 2px 6px;
	font-family: monospace;
	font-size: 10px;
	color: #ccc;
}`;

	override render() {
		return html`\
${this.hints.map(({ key, hint }) => html`
	<div class="control-hint">
		<span class="control-key">${key}</span>
		<span>${hint}</span>
	</div>
`)}`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'control-hints': ControlHints;
	}
}
